import { useState, useMemo, useEffect } from "react";
import useAppStore from "src/stores/appStore";
import { defaultCollectionsLanguagesSelector } from "src/stores/selectors/collectionsSelectors";
import { matchesSearch, matchesFilter } from "../HyroTableContainer.utils";

export const useClientPagination = ({
  initialFilters = [],
  data = [],
  onFiltersChange
}) => {
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState(initialFilters);
  const defaultLanguage = useAppStore(defaultCollectionsLanguagesSelector);

  const rows = useMemo(() => {
    const context = { defaultLanguage };
    const initialRows = data || [];
    let result = initialRows;

    if (searchText) {
      result = result.filter(row => matchesSearch(row, searchText));
    }

    if (filters?.length) {
      result = result.filter(row => filters.every(filterItem => matchesFilter(row, filterItem, context)));
    }

    return result;
  }, [data, filters, searchText, defaultLanguage]);

  useEffect(() => {
    if (onFiltersChange && JSON.stringify(filters) !== JSON.stringify(initialFilters)) {
      onFiltersChange(filters);
    }
  }, [filters, initialFilters, onFiltersChange]);

  return {
    searchText,
    setSearchText,
    filters,
    setFilters,
    rows
  };
};
